import React from 'react';
import { Helmet } from 'react-helmet';
import './Hero.css';
import booksData from './booksData';

const pageUrl = 'https://jerryevanoff.com';
const pageTitle = 'Jerry Evanoff | Murder Mystery and Time Travel Fiction Author';
const pageDescription = 'Jerry Evanoff writes the Sam Norris amateur sleuth Murder Mystery Series and time travel science fiction. Explore his books, series and what\'s next.';

const siteSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Person',
      '@id': `${pageUrl}/#person`,
      name: 'Jerry Evanoff',
      url: pageUrl,
      jobTitle: 'Author',
      description: 'Jerry Evanoff is the author of the Sam Norris Murder Mystery Series, featuring a tech-savvy programmer and amateur sleuth solving modern whodunit mysteries, and time travel science fiction novels.',
      sameAs: [
        'https://jerryevanoffauthor.substack.com/',
        'https://twitter.com/jerrye25',
        'https://www.facebook.com/jerryevanoffauthor',
        'https://www.amazon.com/stores/Jerry-Evanoff/author/B07TSLN98V',
        'https://www.etsy.com/shop/JerryEvanoffAuthor'
      ],
      knowsAbout: [
        'murder mystery novels',
        'amateur sleuth mysteries',
        'modern whodunits',
        'soft-boiled mysteries',
        'Agatha Christie-style mysteries',
        'science fiction',
        'time travel fiction'
      ]
    },
    {
      '@type': 'WebSite',
      '@id': `${pageUrl}/#website`,
      name: 'Jerry Evanoff',
      url: pageUrl,
      description: pageDescription,
      author: { '@id': `${pageUrl}/#person` },
      publisher: { '@id': `${pageUrl}/#person` }
    }
  ]
};

const Hero = () => {
  const heroBook = booksData.find(series => series.books.some(book => book.showInHero));
  const freeGiveawayBooks = booksData.filter(series => series.books.some(book => book.showInFreeGiveaway));

  if (!heroBook || freeGiveawayBooks.length < 2) {
    return null;
  }

  const heroBookData = heroBook.books.find(book => book.showInHero);
  const facebookLink = 'https://www.facebook.com/jerryevanoffauthor';

  return (
    <section className="hero">
      <Helmet>
        <title>{pageTitle}</title>

        <meta name="description" content={pageDescription} />
        <meta name="keywords" content="Jerry Evanoff, author, murder mystery, amateur sleuth mystery, modern whodunit, tech-savvy sleuth, science fiction, time travel fiction, Sam Norris Murder Mystery Series" />
        <meta name="author" content="Jerry Evanoff" />

        <link rel="canonical" href={pageUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:site_name" content="Jerry Evanoff" />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />

        <script type="application/ld+json">
          {JSON.stringify(siteSchema)}
        </script>
      </Helmet>

      <div className="hero-content">

        <div className="hero-left">
          <div className="latest-release">
            <h1 className="hero-title">Latest Release</h1>
            <a
              href={heroBookData.buyLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={heroBookData.cover} alt="Book Cover" className="hero-img" />
            </a>
            <a
              href={heroBookData.buyLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-button"
            >
              {heroBookData.buyButtonText}
            </a>
          </div>
        </div>

        <div className="hero-right">
          <a href={facebookLink} target="_blank" rel="noopener noreferrer" className="facebook-link">
            <div className="facebook-frame">Follow Me On Facebook</div>
          </a>

          <div className="giveaway-section">
            <h2 className="giveaway-label">Claim Your Free Books!</h2>
            <div className="giveaway-books-row">
              {freeGiveawayBooks.map((series, index) => {
                const giveawayBook = series.books.find(book => book.showInFreeGiveaway);
                return (
                  <div className="giveaway-book" key={index}>
                    <a
                      href={giveawayBook.buyLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={giveawayBook.cover} alt="Book Cover" className="giveaway-img" />
                    </a>
                    <p className="giveaway-description">{giveawayBook.freeGiveawayDescription}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <section className="coming-next-section">
            <h2 className="coming-next-title">Want to See What's Coming Next?</h2>
            <p className="coming-next-description">
              Get a sneak peek at upcoming books, bonus content, and exclusive releases.
            </p>
            <a className="coming-next-button" href="/next">Explore What's Next</a>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Hero;